import { NgModule } from '@angular/core';
import { V2LService } from './v2l.service';
import { SharedProviderModule } from '~app/shared/shared.module';

@NgModule({
  imports: [
    SharedProviderModule
  ],
  providers: [V2LService]
})
export class V2LModule {
}
